import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';
import {RoofThickness} from "../../../types/types";

export const usePresenter = () => {
  const { dispatch, appStore, roofStore } = useStoreon<IState, IEvents>('appStore',  'roofStore');

  const setCoatingName = (coatingName: string) => {
    dispatch('roof/set-coating-name', { coatingName });
  };

  const setThicknessName = (thicknessName: RoofThickness) => {
    dispatch('roof/set-thickness-name', { thicknessName });
  };
  return {
    selectedCoating: roofStore.coatingName,
    selectedThickness: roofStore.thicknessName,
    profileType: roofStore.profileType,
    profileName: roofStore.profileType === 'Металлочерепица' ? roofStore.metalTileName : roofStore.pailingName,
    priceList:  appStore.priceList,
    setCoatingName,
    setThicknessName
  };
};
